<template>

    <popup
      buttonText="Add Workflow"
      heading="Add Workflow"
      button-icon="fa fa-plus"
      button-size="small"
      button-style="primary"
      round
      plain
      ref="workflowmodal"
      @save="addWorkflow">

      <edit-workflow is-add :row-data="formData" />

  </popup>

</template>

<script>

import WorkflowMixins from '@/mixins/WorkflowMixins'
import EditWorkflow from '@/components/workflow/EditWorkflow'

export default {
  mixins: [WorkflowMixins],

  components: {
    EditWorkflow
  },

  props: {
    rowIndex: {
      type: Number
    }
  },

  methods: {
    addWorkflow () {
      if (this.formData.name && this.formData.type) {
        this.saveForm(this, '/workflow', null, this.formData, 'Master Workflow', null, null, true, this.WORKFLOW_TABLE_REF)
        this.$emit('close')
        this.$refs.workflowmodal.closeModal()
      } else {
        this.$message({type: 'warning', message: 'Please input a name and a type of workflow.'})
      }
    }  // addWorkflow

  },


  data: function () {
    return {
      dialogVisible: false,
      formData: this.getTableStruct('workflow')
    }
  }

}
</script>



// WEBPACK FOOTER //
// AddWorkflow.vue?50ca466e